import React, { useContext, useState, useRef } from 'react';
import { useMutation } from '@apollo/client';
import {
  Text,
  Button,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from '@chakra-ui/react';
import get from 'lodash/get';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import UserContext from '../../../contexts/UserContext';
import SpinnerContext from '../../../contexts/SpinnerContext';
import Input from '../../../components/Input';
import { CREATE_STRIPE_ACCOUNT } from '../query';
import { useCustomToast } from '../../../hooks/useCustomToast';

const CreateStripeAccountSchema = Yup.object().shape({
  comment: Yup.string().required('Warum möchtest Du den Stripe Customer erstellen?'),
});

export const CreateStripeAccount = ({ packageStationId, refetch }) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const onAlertClose = () => setAlertOpen(false);
  const cancelRef = useRef();

  const { user: internalUser } = useContext(UserContext);
  const { toggleSpinner } = useContext(SpinnerContext);
  const [createStripeAccountMutation] = useMutation(CREATE_STRIPE_ACCOUNT);
  const toast = useCustomToast();

  const handleCreateStripeAccount = async () => {
    try {
      toggleSpinner(true);
      const {
        data: { createStripeCustomer },
      } = await createStripeAccountMutation({
        variables: {
          packageStationId,
          comment: 'Stripe Customer erstellt',
          internalUser: internalUser.id,
        },
      });
      await refetch();
      toast({
        title: 'Erfolg!',
        description: 'Der Stripe Customer wurde erstellt.',
        status: 'success',
      });
      setAlertOpen(false);
    } catch (error) {
      console.log(error);
      toast({
        description: get(error, 'graphQLErrors.0.message', 'Ein Fehler ist aufgetreten!'),
        status: 'error',
      });
    }
    toggleSpinner(false);
  };

  return (
    <>
      <Button variant="outline" colorScheme="brand" size="xs" onClick={() => setAlertOpen(true)}>
        DropPoint Geldpool erstellen
      </Button>

      <AlertDialog isOpen={alertOpen} leastDestructiveRef={cancelRef} onClose={onAlertClose}>
        <AlertDialogOverlay />
        <AlertDialogContent>
          <Formik initialValues={{ comment: '' }} validationSchema={CreateStripeAccountSchema} onSubmit={handleCreateStripeAccount}>
            <Form>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Bist du sicher, dass du einen neuen Stripe Account für diesen DropPoint erstellen möchtest?
              </AlertDialogHeader>

              <AlertDialogBody>
                <Input name="comment" label="Kommentar" />
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onAlertClose}>
                  Abbrechen
                </Button>
                <Button colorScheme="green" type="submit" ml={3}>
                  Stripe Account erstellen
                </Button>
              </AlertDialogFooter>
            </Form>
          </Formik>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
